export default function toNotFoundWord(word) {
    if (word === "Tidak Ada") return "/ Not Found";
    return "";
}
